"use client"
import React, { useState } from 'react';
import { ProudOfNode, UserNode } from 'generated/types';
import Image from 'next/image';
import Link from 'next/link';
import { RaisedHandlIcon } from 'components/icons/v2/RaisedHand';

interface WhatImProudOfProps {
  user?: UserNode | null;
}

export const ProudOf: React.FC<WhatImProudOfProps> = ({ user }) => {
  if (!user?.proudOf?.length) return null;

  return (
    <div className='flex flex-col gap-4'>
      <h3 className='text-large font-semibold text-gray-800'>What I&apos;m proud of</h3>
      <div className='flex flex-col gap-4'>
        {user.proudOf.map((item, index) => (
          <ProudOfItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
};


interface ProudOfItemProps {
  item: Pick<ProudOfNode, 'title' | 'description' | 'imageUrl' | 'url'>;
}

export const ProudOfItem: React.FC<ProudOfItemProps> = ({ item }) => {
const [imageError, setImageError] = useState(false);

  const ImageBlock = () => (
    <div
      className={'flex items-center justify-center w-[90px] h-[55px] text-center flex-shrink-0 rounded-[8px] bg-white ' +
        'transition-all duration-200 ease-out ' +
        'hover:bg-gray-500 hover:shadow-[0_4px_12px_0_hsl(220_13%_91%_/_0.8)] ' +
        'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2'}>
      {item.imageUrl && !imageError ? (
        <Image
          src={item.imageUrl}
          alt={item.title ?? 'URL preview image'}
          width={90}
          height={55}
          unoptimized={true}
          className='w-[90px] h-[55px] object-cover'
          onError={() => setImageError(true)}
        />
      ) : (
        <RaisedHandlIcon className={'text-gray-100'} />
      )}
    </div>
  );

  const ContentBlock = () => (
    <div className='flex-1 min-w-0'>
      {item.title && (
        <h4 className={'text-medium font-medium text-gray-800 underline line-clamp-1'}>
          {item.title}
        </h4>
      )}
      {item.description && (
        <p className={'text-gray-600 text-xs mt-1 line-clamp-2'}>
          {item.description}
        </p>
      )}
    </div>
  );

  return (
    <div className={'flex gap-3 items-center'}>
      {item.url ? (
        <>
          <Link href={item.url} target="_blank" rel="noopener noreferrer">
            <ImageBlock />
          </Link>
          <Link href={item.url} target="_blank" rel="noopener noreferrer">
            <ContentBlock />
          </Link>
        </>
      ) : (
        <>
          <ImageBlock />
          <ContentBlock />
        </>
      )}
    </div>
  );
};